import axios from "./config";

/**
 * @function
 * @name changePassword
 * @description Change user password with enhanced validation
 * @param {Object} passwordData - Password change data
 * @returns {Promise}
 */
const changePassword = (passwordData) => {
    return axios.post('/focal_people/change-password', passwordData).then((response) => response.data);
};

/**
 * @function
 * @name forgotPassword
 * @description Request password reset link
 * @param {Object} data - Contains email
 * @returns {Promise}
 */
const forgotPassword = (data) => {
    return axios.post('/focal_people/forget-password', data).then((response) => response.data);
};

/**
 * @function
 * @name resetPassword
 * @description Reset password using token
 * @param {Object} data - Contains email, token, password, password_confirmation
 * @returns {Promise}
 */
const resetPassword = (data) => {
    return axios.post('/focal_people/reset-password', data).then((response) => response.data);
};

/**
 * @function
 * @name validatePassword
 * @description Validate password against security requirements
 * @param {string} password - Password to validate
 * @returns {Object} Validation result
 */
const validatePassword = (password) => {
    const validations = {
        minLength: password.length >= 8,
        hasUppercase: /[A-Z]/.test(password),
        hasLowercase: /[a-z]/.test(password),
        hasNumber: /\d/.test(password),
        hasSpecial: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };
    
    const isValid = Object.values(validations).every(v => v);
    
    return {
        isValid,
        validations,
        requirements: [
            { key: 'minLength', text: 'At least 8 characters', valid: validations.minLength },
            { key: 'hasUppercase', text: 'One uppercase letter', valid: validations.hasUppercase },
            { key: 'hasLowercase', text: 'One lowercase letter', valid: validations.hasLowercase },
            { key: 'hasNumber', text: 'One number', valid: validations.hasNumber },
            { key: 'hasSpecial', text: 'One special character', valid: validations.hasSpecial }
        ]
    };
};

const passwordManagementAPI = {
    changePassword,
    forgotPassword,
    resetPassword,
    validatePassword,
};

export default passwordManagementAPI;